<template>
    <grid :columnDefs="columnDefs" :rowData="rowData" :isAutoWidth="true"> </grid>
</template>

<script>
import api from '../../../api';
import { GUEST_VERIFICATIONS_ENDPOINT } from '../../../endpoints';
import { formatResponseError } from '../../../utils/api';
import grid from '../../generic/grid/grid.vue';
import GuestVerificationRequestModal from '../../common/guest-verification-request-modal.vue';
export default {
    components: { grid, GuestVerificationRequestModal },
    data() {
        return {
            rowData: [],
        };
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'meta_reservation',
                    headerName: 'Invoice',
                    cellRenderer: ({ data }) =>
                        `<a href="/app/reservation/edit/invoice/${data.meta_reservation}">${data.meta_reservation}</a>`,
                },
                {
                    field: 'created',
                    type: 'dateTimeColumn',
                    headerName: 'Created',
                },
                {
                    field: 'arrival_date',
                    headerName: 'Arrival Date',
                    type: 'dateColumn',
                },
                {
                    field: 'guest',
                    headerName: 'Guest',
                    autoWidthExclude: true,
                },
                {
                    field: 'seen',
                    headerName: 'Seen',
                    type: 'yesNoColumn',
                },
                {
                    field: 'seen_on',
                    headerName: 'Seen On',
                    type: 'dateColumn',
                    minWidth: 100,
                    cellRendererParams: {
                        noValue: 'Not seen',
                    },
                },
            ];
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                this.$parent.$emit('handleBusy', true);
                const { data } = await api.get(`${GUEST_VERIFICATIONS_ENDPOINT()}pending/`);
                this.rowData = data;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not fetch verifications',
                });
            } finally {
                this.$parent.$emit('handleBusy', false);
            }
        },
    },
};
</script>

<style>
</style>